import React from 'react';
import Checkbox from 'material-ui/Checkbox';

class CheckboxOptionsWithTitle extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      ...props
    };
  }

  componentWillReceiveProps(nextProps) {
    this.setState({...nextProps});
  }

  onChange = (value) => {
    this.setState({value});
    if (this.props.onChange) {
      this.props.onChange(
        value
      );
    }
  };

  render() {
  
    let options = [];

    if (this.state.options) {
      options = this.state.options.map((option) =>
        <li>
          <Checkbox label={option.name} checked={option.enabled} onCheck={(e, newValue)=> { 
            option.enabled = newValue;
            this.forceUpdate();
          }} />
        </li>
      );
    }
    

    return (
    <div>
      <div>{this.state.title}</div>
      <hr />
      <ul>
        {options}
      </ul>
    </div>
    );
  }
}

export default CheckboxOptionsWithTitle;


// WEBPACK FOOTER //
// ./src/components/CheckboxOptionsWithTitle.js